import { bold, cyan, darkGrey } from './ansiHelpers.js';
import { getTimestamp } from './getTimestamp.js';

export type StickyType = 'spinning' | 'static';

export const spinCharacters = ['⠋', '⠙', '⠸', '⠴', '⠦', '⠇'];

/**
 * Sticky text. It can be either static or include a spinner with a timestamp.
 */
export class Sticky {
  // Randomize the spinner start index except in tests. This looks better in cases where each
  // sticky might not survive for multiple reprints (so it doesn't repeatedly show the first
  // spinner character and appear "stuck").
  // eslint-disable-next-line no-restricted-properties -- don't want environment package dependency
  private _spinnerIndex = process.env.JEST_WORKER_ID ? 0 : Math.floor(Math.random() * spinCharacters.length);
  private _text: string;
  private _type: StickyType;

  constructor(text: string, type: StickyType = 'static') {
    this._text = text;
    this._type = type;
  }

  /**
   * Get the sticky text. NOTE: for a spinning sticky, this will advance the spinner character,
   * so get the value once before doing any calculations or printing.
   */
  public getText(): string {
    if (this._type === 'static') {
      return this._text;
    }

    // Increment the spinner index on each access to simulate spinning without the overhead of
    // events and timers
    const text = `${darkGrey(`[${getTimestamp()}]`)} ${spinCharacters[this._spinnerIndex]} ${bold(cyan(this._text))}`;
    this._spinnerIndex = (this._spinnerIndex + 1) % spinCharacters.length;
    return text;
  }
}
